<h3 class="page-subheader" *ngIf="title">{{ title }}</h3>

<div class="row form-row">
    <div class="col-4">
        <app-select [ngModel]="data.manual.type?.code"
                    (ngModelChange)="type = $event"
                    [itemList]="(dictionaries$ | async)[dictionaryTypes.VEHICLE_TYPE].itemList"
                    [label]="'MOTOR_CONFIG.MOTOR_TYPE' | translate"
                    [placeholder]="'LABEL.PICK' | translate"
                    [errorStateMatcher]="matchers.manual.type">
        </app-select>
    </div>
    <div class="col-4">
        <app-numeric [(ngModel)]="data.productionYear"
                     [config]="{thousands: '', maxLength: 4}"
                     [label]="'MOTOR_CONFIG.MANUFACTURE_YEAR' | translate"
                     [errorStateMatcher]="matchers.productionYear">
        </app-numeric>
    </div>

    <div class="col-4">
        <app-input [(ngModel)]="data.manual.make"
                   [label]="'MOTOR_CONFIG.MAKE' | translate"
                   [errorStateMatcher]="matchers.manual.make">
        </app-input>
    </div>
</div>

<div class="row form-row">
    <div class="col-4">
        <app-input [(ngModel)]="data.manual.model"
                   [label]="'MOTOR_CONFIG.MODEL' | translate"
                   [errorStateMatcher]="matchers.manual.model">
        </app-input>
    </div>
    <div class="col-4">
        <app-select [ngModel]="data.manual.bodyType?.code"
                    (ngModelChange)="data.manual.bodyType = {code: $event}"
                    [itemList]="(dictionaries$ | async)[dictionaryTypes.VEHICLE_BODY_TYPE].itemList | flexFilter : data.manual.type?.code"
                    [disabled]="!data.manual.type?.code"
                    [label]="'MOTOR_CONFIG.BODY_TYPE' | translate"
                    [placeholder]="'LABEL.PICK' | translate"
                    [errorStateMatcher]="matchers.manual.bodyType">
        </app-select>
    </div>
    <div class="col-4">
        <app-select [ngModel]="data.manual.doors?.code"
                    (ngModelChange)="data.manual.doors = {code: $event}"
                    [itemList]="(dictionaries$ | async)[dictionaryTypes.VEHICLE_DOORS].itemList"
                    [label]="'MOTOR_CONFIG.DOOR_NUMBER' | translate"
                    [placeholder]="'LABEL.PICK' | translate"
                    [errorStateMatcher]="matchers.manual.doors">
        </app-select>
    </div>
</div>


<div class="row form-row">
    <div class="col-4">
        <app-select [ngModel]="data.manual.fuelType?.code"
                    (ngModelChange)="data.manual.fuelType = {code: $event}"
                    [itemList]="(dictionaries$ | async)[dictionaryTypes.VEHICLE_FUEL_TYPE].itemList | flexFilter : data.manual.type?.code"
                    [disabled]="!data.manual.type?.code"
                    [label]="'MOTOR_CONFIG.FUEL_TYPE' | translate"
                    [placeholder]="'LABEL.PICK' | translate"
                    [errorStateMatcher]="matchers.manual.fuelType">
        </app-select>
    </div>
    <div class="col-4">
        <app-input [(ngModel)]="data.manual.version"
                   [label]="'MOTOR_CONFIG.VERSION' | translate"
                   [errorStateMatcher]="matchers.manual.version">
        </app-input>
    </div>
    <div class="col-4">
        <app-numeric [(ngModel)]="data.manual.engineCapacity"
                     [config]="{thousands: ''}"
                     [label]="'MOTOR_CONFIG.ENGINE_SIZE' | translate"
                     [suffix]="'LABEL.SUFFIX_CM3' | translate"
                     [errorStateMatcher]="matchers.manual.engineCapacity">
        </app-numeric>
    </div>
</div>

<div class="row form-row">
    <div class="col-4">
        <app-numeric [(ngModel)]="data.manual.enginePower"
                     [config]="{thousands: ''}"
                     [label]="'MOTOR_CONFIG.KW' | translate"
                     [suffix]="'LABEL.SUFFIX_KW' | translate"
                     [errorStateMatcher]="matchers.manual.enginePower">
        </app-numeric>
    </div>
    <div class="col-4">
        <app-numeric [(ngModel)]="data.manual.loadCapacity"
                     [config]="{thousands: ''}"
                     [label]="'MOTOR_CONFIG.LOAD_CAPACITY' | translate"
                     [suffix]="'LABEL.SUFFIX_KG' | translate"
                     [errorStateMatcher]="matchers.manual.loadCapacity">
        </app-numeric>
    </div>
    <div class="col-4">
        <app-numeric [(ngModel)]="data.manual.maximumWeight"
                     [config]="{thousands: ''}"
                     [label]="'MOTOR_CONFIG.MAXIMUM_WEIGHT' | translate"
                     [suffix]="'LABEL.SUFFIX_KG' | translate"
                     [errorStateMatcher]="matchers.manual.maximumWeight">
        </app-numeric>
    </div>
</div>

<div class="separator"></div>
